export default {
    "downloadReport_loading": "Loading...",
    "downloadReport_success": "Download completed",
    "downloadReport_downloading": "Downloading...",
    "downloadReport_manualClose_title": "✅ Download completed",
    "downloadReport_manualClose_message": "You can safely close this window.",
    "downloadReport_manualClose_button": "Close window",
    "downloadReport_error": "Download error",
    "downloadReport_error_message": "Download error. Please try again.",
    "downloadReport_expired_link": "Expired link",
    "downloadReport_generic_error": "System error"
}
